// Angular
import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

// Services
import { SoledadSearchService } from '../../../shared/services/b2b/search.service';

@Injectable()
export class FilterTopEffects {
    constructor(private actions$: Actions, private searchService: SoledadSearchService) {}
}
